import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  selectFormStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import * as Yup from "yup";
import { useFormik } from "formik";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import ClipLoader from "react-spinners/ClipLoader";
import Select from "react-select";
import { ToastContainer } from "react-toastify";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValues = {
  fullName: "",
  email: "",
  mobileNumber: "",
  designation: "",
  countryOfResidency: "",
  companyName: "",
  countryOfIncorporation: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  fullName: Yup.string()
    .trim()
    // .required("Full Name is required")
    .matches(/^[A-Za-z]+(?:\s[A-Za-z]+)+$/, "Full name is not valid"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(onlyIntRegExp, "Mobile number is not valid")
    .min(10, "Mobile number is not valid")
    .max(16, "Mobile number is not valid"),
  // designation: Yup.string().trim().required("Select Designation"),
  // countryOfResidency: Yup.string()
  //   .trim()
  //   .required("Country Of Residency is required"),
  // companyName: Yup.string().trim().required("Company Name is required"),
  // countryOfIncorporation: Yup.string()
  //   .trim()
  //   .required("Country Of Incorporation is required"),
});

const PersonalInformation = () => {
  ChangeTitle("Personal Information");
  const [loading, setLoading] = useState();
  const [designationList, setDesignationList] = useState([]);

  // Personal Info save Api Call
  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        fullName: values.fullName,
        email: values.email,
        mobileNumber: values.mobileNumber,
        designationId: values.designation,
        countryOfResidency: values.countryOfResidency,
        companyName: values.companyName,
        countryOfIncorporation: values.countryOfIncorporation,
      };

      const response = await postData(
        "private/user/personal/information",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          viewPersonalInfo();
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Personal Info Get API Call
  const viewPersonalInfo = async () => {
    const param = {};
    var response = await getData(
      "private/user/personal/information/detail",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      formik.setValues({
        fullName: data.fullName,
        email: data.email,
        mobileNumber: data.mobileNumber,
        designation: data.designationId,
        countryOfResidency: data.countryOfResidency,
        companyName: data.companyName,
        countryOfIncorporation: data.countryOfIncorporation,
      });
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Designation API Call
  const viewDesignationList = async () => {
    const param = {};
    var response = await postData("designation/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.designationName,
        };
      });
      setDesignationList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewDesignationList();
    viewPersonalInfo();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Personal information
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full lg:w-[80%] p-[3rem] mx-auto relative form-box">
            <div className="">
              <form onSubmit={formik.handleSubmit}>
                <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[2rem] mb-[2rem]">
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label mb-4"
                    >
                      Full name
                    </label>
                    <input
                      className="w-full form-input"
                      type="text"
                      placeholder="Enter full name"
                      name="fullName"
                      id="fullName"
                      value={formik.values.fullName}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.fullName && formik.errors.fullName && (
                      <div className="mt-2 error-msg">
                        <div className="">{formik.errors.fullName}</div>
                      </div>
                    )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      Email address
                    </label>
                    <input
                      className="w-full form-input"
                      type="email"
                      placeholder="Enter email address"
                      id="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="mt-2 error-msg">
                        <div className="">{formik.errors.email}</div>
                      </div>
                    )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      Mobile number
                    </label>
                    <input
                      className="w-full form-input"
                      type="text"
                      placeholder="Enter mobile number"
                      id="mobileNumber"
                      value={formik.values.mobileNumber}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.mobileNumber &&
                      formik.errors.mobileNumber && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.mobileNumber}</div>
                        </div>
                      )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label mb-4"
                    >
                      Designation
                    </label>
                    <Select
                      name="designation"
                      id="designation"
                      placeholder="Select designation"
                      className="w-full form-select form-input"
                      isSearchable={true}
                      options={designationList}
                      value={
                        designationList.find(
                          (item) => item.value === formik.values.designation
                        ) || ""
                      }
                      onChange={(e) =>
                        formik.setFieldValue("designation", e.value)
                      }
                      styles={selectFormStyle}
                    />
                    {formik.touched.designation &&
                      formik.errors.designation && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.designation}</div>
                        </div>
                      )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label mb-4"
                    >
                      Country of residency
                    </label>
                    <input
                      className="w-full form-input"
                      type="text"
                      placeholder="Enter country of residency"
                      name="countryOfResidency"
                      id="countryOfResidency"
                      value={formik.values.countryOfResidency}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.countryOfResidency &&
                      formik.errors.countryOfResidency && (
                        <div className="mt-2 error-msg">
                          <div className="">
                            {formik.errors.countryOfResidency}
                          </div>
                        </div>
                      )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label mb-4"
                    >
                      Company name
                    </label>
                    <input
                      className="w-full form-input"
                      type="text"
                      placeholder="Enter company name"
                      name="companyName"
                      id="companyName"
                      value={formik.values.companyName}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.companyName &&
                      formik.errors.companyName && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.companyName}</div>
                        </div>
                      )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label mb-4"
                    >
                      Country of incorporation
                    </label>
                    <input
                      className="w-full form-input"
                      type="text"
                      placeholder="Enter country of incorporation"
                      name="countryOfIncorporation"
                      id="countryOfIncorporation"
                      value={formik.values.countryOfIncorporation}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.countryOfIncorporation &&
                      formik.errors.countryOfIncorporation && (
                        <div className="mt-2 error-msg">
                          <div className="">
                            {formik.errors.countryOfIncorporation}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                <div className="w-full justify-center gap-5 flex">
                  <button
                    type="submit"
                    className="btn-submit"
                    disabled={loading}
                  >
                    {!loading && <>Submit</>}
                    {loading && (
                      <div className="flex items-center gap-3">
                        <span className="" style={{ display: "block" }}>
                          Please wait...{" "}
                        </span>
                        <ClipLoader
                          color={"#ffffff"}
                          loading={loading}
                          size={20}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </div>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalInformation;
